<template>
  <!-- 微信支付弹窗 -->
  <el-dialog
    title="支付宝扫码支付"
    :visible.sync="centerDialogVisible"
    width="400px"
    @close="cancelOrderPay"
    center
    append-to-body
    :close-on-click-modal="false"
  >
    <!-- <span>{{wxPayInfo.barcodeText}}</span> -->
    <div class="content">
      <div class="qr_text">请使用支付宝“扫一扫”功能扫描下方二维码进行支付</div>
      <div class="qr_text">
        本次支付金额：<span style="color: #e28a56; font-weight: 700">{{
          aliPayOrder.price
        }}</span
        >元
      </div>
      <div class="qr_text">支付过程中请勿关闭或离开此页面</div>
      <div class="qr_code">
        <iframe
          :srcdoc="aliPayOrder.barcodeText"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          scrolling="no"
          width="200"
          height="200"
          @load="isLoading = false"
          style="overflow: hidden"
        >
        </iframe>
         <div v-if="isLoading" id="loading-indicator">加载中...</div>
      </div>
      <div class="order_pay">
        <div class="order_code">订单编号: {{ aliPayOrder.orderCode }}</div>
        <div class="order_status">
          支付状态: {{ payStatus.tradeStateDesc }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelOrderPay">取消支付</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryAliOrderByOutTradeNo , cancelOrder } from "@/api/request";
export default {
  name: "",
  props: {
    aliPayOrder: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      centerDialogVisible: true,
      getPayStatus: null,
      isLoading: true,
      payStatus: {
        tradeStateDesc: "订单未支付",
      }, //订单支付状态
    };
  },
  methods: {
    hideLoadingIndicator(){
        document.getElementById('loading-indicator').style.display = 'none';
    },
    init(data){
      this.getPayStatus = setInterval(() => {
        queryAliOrderByOutTradeNo({orderCode: this.aliPayOrder.orderCode,}).then((res) => {
          let data = res.data
          const subCodeActions = {
            // 交易不存在
            'ACQ.TRADE_NOT_EXIST': () =>{
                this.payStatus.tradeStateDesc = '等待订单创建'
            },
            // 无权限使用接口
            'ACQ.ACCESS_FORBIDDEN': () => {
                 this.payStatus.tradeStateDesc = '支付端接口异常'
                 this.$message.warning("支付端接口异常，请联系服务商");
                 this.cancelOrderPay()
            },
            // 买家余额不足
            'ACQ.BUYER_BALANCE_NOT_ENOUGH': () => {
                this.payStatus.tradeStateDesc = '待支付'
                this.$message.warning("买家余额不足");
            },
            // 用户银行卡余额不足
            'ACQ.BUYER_BANKCARD_BALANCE_NOT_E': () => {
                this.payStatus.tradeStateDesc = '待支付'
                this.$message.warning("用户银行卡余额不足");
            },
            // 买家状态非法
            'ACQ.BUYER_ENABLE_STATUS_FORBID': () => {
                 this.payStatus.tradeStateDesc = '订单异常'
                 this.$message.warning("订单异常，买家状态非法，请联系服务商");
                 this.cancelOrderPay()
            },
            // 买家付款日限额超限
            'ACQ.BUYER_PAYMENT_AMOUNT_DAY_LIM': () => {
                this.payStatus.tradeStateDesc = '买家付款日限额超限'
                this.$message.warning("买家付款日限额超限");
            },
            // 买家付款月额度超限
            'ACQ.BUYER_PAYMENT_AMOUNT_MONTH_L': () => {
                this.payStatus.tradeStateDesc = '买家付款月额度超限'
                this.$message.warning("买家付款月额度超限");
            },
            // 买卖家不能相同
            'ACQ.BUYER_SELLER_EQUAL': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，买卖家不能相同，更换买家重新付款");
                this.cancelOrderPay()
            },
            // 交易信息被篡改
            'ACQ.CONTEXT_INCONSISTENT': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，交易信息被篡改，请重新创建支付订单");
                this.cancelOrderPay()
            },
            // 余额支付功能关闭
            'ACQ.ERROR_BALANCE_PAYMENT_DISABL': () => {
                this.payStatus.tradeStateDesc = '待支付'
                this.$message.warning("余额支付功能关闭");
            },
            // 买家未通过人行认证
            'ACQ.ERROR_BUYER_CERTIFY_LEVEL_LI': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，买家未通过人行认证，请联系服务商");
                this.cancelOrderPay()
            },
            // 订单信息中包含违禁词
            'ACQ.EXIST_FORBIDDEN_WORD': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，订单信息中包含违禁词，请联系服务商");
                this.cancelOrderPay()
            },
            // 无效的签约有效期
            'ACQ.ILLEGAL_SIGN_VALIDTY_PERIOD': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，无效的签约有效期，请联系服务商");
                this.cancelOrderPay()
            },
            // 参数无效
            'ACQ.INVALID_PARAMETER': () => {
                this.payStatus.tradeStateDesc = '支付端接口异常'
                this.$message.warning("支付端接口异常，请联系服务商");
                this.cancelOrderPay()
            },
            // 商户协议不存在
            'ACQ.MERCHANT_AGREEMENT_NOT_EXIST': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，请联系服务商");
                this.cancelOrderPay()
            },
            // 没用可用的支付工具
            'ACQ.NO_PAYMENT_INSTRUMENTS_AVAIL': () => {
                this.payStatus.tradeStateDesc = '待支付'
                this.$message.warning("没用可用的支付工具");
            },
            // 应用APP_ID填写错误
            'ACQ.PARTNER_ERROR': () => {
                this.payStatus.tradeStateDesc = '支付端接口异常'
                this.$message.warning("支付端接口异常，请联系服务商");
                this.cancelOrderPay()
            },
            // 支付失败
            'ACQ.PAYMENT_FAIL': () => {
                this.payStatus.tradeStateDesc = '支付失败'
                this.$message.error("支付失败，请重新生成支付订单");
                this.cancelOrderPay()
            },
            // 支付有风险
            'ACQ.PAYMENT_REQUEST_HAS_RISK': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，支付有风险，请更换其它付款方式");
                this.cancelOrderPay()
            },
            // 当前交易未传入IP信息，创单失败，请传入IP后再发起支付
            'ACQ.RISK_MERCHANT_IP_NOT_EXIST': () => {
                this.payStatus.tradeStateDesc = '支付端接口异常'
                this.$message.warning("支付端接口异常，请联系服务商");
                this.cancelOrderPay()
            },
            // 接口返回错误
            'ACQ.SYSTEM_ERROR': () => {
                this.payStatus.tradeStateDesc = '支付端接口异常'
                this.$message.warning("支付端接口异常，请联系服务商");
                this.cancelOrderPay()
            },
            // 订单总金额不在允许范围内
            'ACQ.TOTAL_FEE_EXCEED': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，订单总金额不在允许范围内，请修改订单金额");
                this.cancelOrderPay()
            },
            // 交易买家不匹配
            'ACQ.TRADE_BUYER_NOT_MATCH': () => {
                this.payStatus.tradeStateDesc = '订单异常'
                this.$message.warning("订单异常，交易买家不匹配，请重新创建支付订单");
                this.cancelOrderPay(true)
            },
            // 交易已经关闭
            'ACQ.TRADE_HAS_CLOSE': () => {
                this.payStatus.tradeStateDesc = '交易已经关闭'
                this.$message.warning("交易被关闭，请重新生成支付订单");
                this.cancelOrderPay(true)
            },
            // 交易已被支付
            'ACQ.TRADE_HAS_SUCCESS': () => {
                this.payStatus.tradeStateDesc = '交易已被支付'
                this.$message.success("交易已被支付,请查看预约单支付状态");
                this.cancelOrderPay()
            },
          }
          const tradeStatusActions = {
            // 交易创建
            'WAIT_BUYER_PAY': () => {
                this.payStatus.tradeStateDesc = '待支付';
            },
            // 交易关闭
            'TRADE_CLOSED': () => {
                this.payStatus.tradeStateDesc = '交易关闭';
                this.$message.warning("交易被关闭，请重新生成支付订单");
                this.cancelOrderPay(true);
            },
            // 交易完结
            'TRADE_FINISHED': () => {
                this.payStatus.tradeStateDesc = '交易完结';
                this.$message.success("交易完结,请等待预约订单生成");
                this.creatOrder();
            },
            // 支付成功
            'TRADE_SUCCESS': () => {
                this.payStatus.tradeStateDesc = '支付成功';
                this.$message.success("支付成功,请等待预约订单生成");
                this.creatOrder();
            }
          }
          const subCodeAction = subCodeActions[data.subCode];
          const tradeStatusAction = tradeStatusActions[data.tradeStatus];
          if (subCodeAction) subCodeAction.call(this);
          if (tradeStatusAction) tradeStatusAction.call(this);
        })
      }, 1000)
    },
    cancelAliPayOrder(){
        //如果从订单列表进来会有orderId 下单正常流程没有orderId 这个时候提示用户更换支付方式活或者去订单列表取消订单
        if(this.aliPayOrder.orderId){
            cancelOrder({ orderId: this.aliPayOrder.orderId, cancelFlag: 1 }).then(res => {
                this.$message.success("订单已取消，请重新下单");
                this.$emit("closeALiPayOrder",true);
            })
        }else{
            // this.$message.error("支付订单已被关闭，请更换支付方式或重新下单");
            this.$emit("closeALiPayOrder",false);
        }
        
    },
    //e true 需要取消订单 false 不需要取消订单 直接关闭弹窗
    cancelOrderPay(e) {
      clearInterval(this.getPayStatus);
      if(this.aliPayOrder.flag){
        this.$emit("closeALiPayOrder",false);
      }else{
        if(e){
            this.cancelAliPayOrder()
        }else{
            this.$emit("closeALiPayOrder",false);
        }
      }
    },
    creatOrder() {
      clearInterval(this.getPayStatus);
      this.centerDialogVisible = false
      this.$emit("creatALiPayOrder");
    }
  },
};
</script>

<style lang='scss' scoped>
.content {
  // display: flex;
  text-align: center;
  .qr_text {
    color: #8c8c8c;
    line-height: 30px;
  }
  .order_pay {
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 12px;
  }
}
</style>